<template>
  <div class="offers-page">

    <div class="offers-page-header">
      <offers-page-header/>
    </div>

    <div class="offers-body">
      <offers-body />
    </div>

  </div>

</template>

<script>
import OffersPageHeader from "@/features/offers/OffersPageHeader.vue";
import OffersBody from "@/features/offers/OffersBody.vue";

export default {
  name: "OffersPage",
  components: {OffersPageHeader, OffersBody},

}
</script>

<style scoped>
.offers-page{
  position: relative;
  height: 100%;
  background-color: #f8f8f8;
}

.offers-page-header{
  background-color: white;
}
</style>

<style lang="scss">
[flyer-orientation='vertical'] [page-id='offersPage'].section-container {
	&>.flyer-block .offers-page {
		padding-bottom: 30px;
	}
  &>.flyer-block.OffersPage {
		grid-area: span 4 / span 2 / auto / auto !important;
	}
}
</style>